import Vue from 'vue'
import './plugins'
import App from './App.vue'

import service from './services'
import servicePlugin from './plugins/service'

import router from './router/index'
import VueRouter from 'vue-router'

import '@/assets/global.styl'
import echarts from 'echarts/dist/echarts.min.js'
import VCharts from 'v-charts'
import china from 'echarts/map/json/china.json'
import moment from 'moment'
import Vuex from 'vuex'
import _ from 'lodash'
import store from './store/store'
import { encrypt, decrypt } from '@/utils/jsencrypt'

if (process.env.NODE_ENV === 'development') {
  require('./mock/mock.js')
}

Vue.prototype.$EventBus = new Vue()
echarts.registerMap('china', china)
Vue.prototype.$echarts = echarts
Vue.config.productionTip = false
Vue.prototype.$moment = moment
Vue.prototype._ = _
Vue.prototype.$encrypt = encrypt
Vue.prototype.$decrypt = decrypt
Vue._watchers = Vue.prototype._watchers = []
Vue.use(VCharts)
Vue.use(servicePlugin)
Vue.use(VueRouter)
Vue.use(Vuex)

service.init(() => {
  new Vue({
    service,
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
})
